function formatDate(date: any) {
    // Retourne toujours une date ISO "yyyy-MM-ddTHH:mm:ss" :
    // convertible en datetime quel que soit le DATEFORMAT du serveur SQL
    // (mdy en prod anglais, dmy en local francais).
    let d = String(date ?? '').trim();

    // "dd/MM/yyyy" -> "yyyy-MM-dd"
    const m = d.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (m) {
        d = `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`;
    } else {
        // "dd-MM-yyyy" -> "yyyy-MM-dd"
        const m2 = d.match(/^(\d{1,2})-(\d{1,2})-(\d{4})/);
        if (m2) {
            d = `${m2[3]}-${m2[2].padStart(2, '0')}-${m2[1].padStart(2, '0')}`;
        }
    }

    // Deja ISO avec heure ? on garde tel quel (sans le 'Z' ambigu)
    if (/^\d{4}-\d{2}-\d{2}T/.test(d)) {
        return d.replace(/\.?\d*Z?$/, '');
    }

    return d + 'T00:00:00';
}

export default formatDate;
